import { Radio } from "@/atoms"
import { useTranslation } from "@/hooks/useTranslation"
import { ThunderboltOutlined } from "@/icons"
import { Form } from "@/organisms/Form/Form"
import { RadioGroup } from "../RadioGroup"
import { SectionFormTemplate } from "../SectionFormTemplate"

import { ActionsSectionFormProps } from "."

const sectionId = "actions-section-form"

export const ActionsSectionForm = (props: ActionsSectionFormProps) => {
  const { t } = useTranslation("translation", { keyPrefix: "forms" })
  const { fieldName = "action", title = t("sections.actions") } = props

  return (
    <SectionFormTemplate
      id={sectionId}
      title={title}
      Icon={ThunderboltOutlined}
    >
      <Form.Item required={false} name={fieldName} rules={props.rules}>
        <RadioGroup id="radio_group_actions_section_form">
          <Radio value="WARN">{t("actions.warn")}</Radio>
          <Radio value="FAIL">{t("actions.fail")}</Radio>
        </RadioGroup>
      </Form.Item>
    </SectionFormTemplate>
  )
}

ActionsSectionForm.sectionId = sectionId
